import {
  SET_ANREDEN,
  SET_AKADEMISCHER_TITEL,
  SET_EMAIL_TYPEN,
  SET_BONITAETEN,
  SET_GESCHLECHTER,
  SET_FUNKTIONSBEREICHE,
  SET_INTERESSEN,
  SET_ZIVILSTAENDE,
  SET_NATIONALITAETEN,
  SET_SPRACHEN,
  SET_AUFENTHALTSBEWILLIGUNGEN,
  SET_ANSTELLLUNGS_ARTEN,
  SET_AKTIVITAETS_STATI,
  SET_KANTONE,
  SET_PARTNERROLLEN,
  SET_DOZENTEN,
  SET_QUALIFIKATION_TYPEN,
  SET_QUALIFIKATION_NIVEAU,
  SET_POSTLEITZAHLEN,
  SET_ADRESS_VERWENDUNG_TYPEN,
  SET_RELATION_TYPEN,
  SET_RELATION_ARTEN,
  SET_RELATION_STATI,
  SET_FIRMA_PARTNERROLLEN,
  SET_BRANCHEN,
  SET_KOMPETENZSTUFEN,
  SET_UNTERRICHTSSPRACHEN,
  SET_EINREICHUNGSTATI,
  SET_KONKORDATE,
  SET_INSTITUTIONEN,
  SET_ERNAEHRUNGEN,
} from "./mutations.type";

import {
  LADE_AUSWAHLWERTE_GESCHAEFTSPARTNER,
  LADE_DOZENTEN,
} from "./actions.type";

import Api from "../../api/Api";
import AppApi from "../../api/AppApi";
import {SET_VERSANDART} from "../auftrag/mutations.type";

export default {
  namespaced: true,
  state: {
    emailtypen: [],
    bonitaten: [],
    geschlechter: [],
    funktionsbereiche: [],
    anreden: [],
    akademischetitel: [],
    interessen: [],
    zivilstaende: [],
    nationalitaeten: [],
    sprachen: [],
    aufenthaltsbewilligungen: [],
    anstellungsarten: [],
    aktivitaetsstati: [],
    kantone: [],
    partnerrollen: [],
    dozenten: [],
    qualifikationtypen: [],
    niveau: [],
    postleitzahlen: [],
    adressverwendungstypen: [],
    relationtypen: [],
    relationarten: [],
    relationsstati: [],
    firma_partnerrollen: [],
    branchen: [],
    kompetenzstufen: [],
    unterrichtssprachen: [],
    einreichungstati: [],
    konkordate: [],
    institutionen: [],
    ernaehrungen: [],
  },
  mutations: {
    [SET_EMAIL_TYPEN](state, val) {
      state.emailtypen = val;
    },
    [SET_BONITAETEN](state, val) {
      state.bonitaeten = val;
    },
    [SET_GESCHLECHTER](state, val) {
      state.geschlechter = val;
    },
    [SET_FUNKTIONSBEREICHE](state, val) {
      state.funktionsbereiche = val;
    },
    [SET_ANREDEN](state, val) {
      state.anreden = val;
    },
    [SET_AKADEMISCHER_TITEL](state, val) {
      state.akademischetitel = val;
    },
    [SET_INTERESSEN](state, val) {
      state.interessen = val;
    },
    [SET_ZIVILSTAENDE](state, val) {
      state.zivilstaende = val;
    },
    [SET_NATIONALITAETEN](state, val) {
      state.nationalitaeten = val;
    },
    [SET_SPRACHEN](state, val) {
      state.sprachen = val;
    },
    [SET_AUFENTHALTSBEWILLIGUNGEN](state, val) {
      state.aufenthaltsbewilligungen = val;
    },
    [SET_ANSTELLLUNGS_ARTEN](state, val) {
      state.anstellungsarten = val;
    },
    [SET_AKTIVITAETS_STATI](state, val) {
      state.aktivitaetsstati = val;
    },
    [SET_KANTONE](state, val) {
      state.kantone = val;
    },
    [SET_PARTNERROLLEN](state, val) {
      state.partnerrollen = val;
    },
    [SET_DOZENTEN](state, val) {
      state.dozenten = val;
    },
    [SET_QUALIFIKATION_TYPEN](state, val) {
      state.qualifikationtypen = val;
    },
    [SET_QUALIFIKATION_NIVEAU](state, val) {
      state.niveau = val;
    },
    [SET_POSTLEITZAHLEN](state, val) {
      state.postleitzahlen = val;
    },
    [SET_ADRESS_VERWENDUNG_TYPEN](state, val) {
      state.adressverwendungstypen = val;
    },
    [SET_RELATION_TYPEN](state, val) {
      state.relationtypen = val;
    },
    [SET_RELATION_ARTEN](state, val) {
      state.relationarten = val;
    },
    [SET_RELATION_STATI](state, val) {
      state.relationsstati = val;
    },
    [SET_FIRMA_PARTNERROLLEN](state, val) {
      state.firma_partnerrollen = val;
    },
    [SET_BRANCHEN](state, val) {
      state.branchen = val;
    },
    [SET_KOMPETENZSTUFEN](state, val) {
      state.kompetenzstufen = val;
    },
    [SET_UNTERRICHTSSPRACHEN](state, val) {
      state.unterrichtssprachen = val;
    },
    [SET_EINREICHUNGSTATI](state, val) {
      state.einreichungstati = val;
    },
    [SET_KONKORDATE](state, val) {
      state.konkordate = val;
    },
    [SET_INSTITUTIONEN](state, val) {
      state.institutionen = val;
    },
    [SET_ERNAEHRUNGEN](state, val) {
      state.ernaehrungen = val;
    },
  },
  actions: {
    async [LADE_AUSWAHLWERTE_GESCHAEFTSPARTNER](context) {
      let response = await Api.get("geschaeftspartner/auswahlwerte/");
      context.commit(SET_NATIONALITAETEN, response.data.nationalitaeten);
      context.commit(
        SET_AUFENTHALTSBEWILLIGUNGEN,
        response.data.aufenthaltsbewilligungen
      );
      context.commit(SET_AKTIVITAETS_STATI, response.data.aktivitaetsstati);
      context.commit(SET_PARTNERROLLEN, response.data.partnerrollen);
      context.commit(SET_POSTLEITZAHLEN, response.data.postleitzahlen);
      context.commit(SET_RELATION_ARTEN, response.data.relationarten);
      context.commit(SET_RELATION_STATI, response.data.relationsstati);
      context.commit(
        SET_FIRMA_PARTNERROLLEN,
        response.data.firma_partnerrollen
      );

      let responseAppApi = await AppApi.get("auswahlwerte/geschaeftspartner/");
      context.commit(SET_BONITAETEN, responseAppApi.data.bonitaeten);
      context.commit(SET_EMAIL_TYPEN, responseAppApi.data.emailtypen);
      context.commit(SET_GESCHLECHTER, responseAppApi.data.geschlechter);
      context.commit(SET_FUNKTIONSBEREICHE, responseAppApi.data.funktionsbereiche);
      context.commit(SET_ANREDEN, responseAppApi.data.anreden);
      context.commit(SET_INTERESSEN, responseAppApi.data.interessen);
      context.commit(SET_ZIVILSTAENDE, responseAppApi.data.zivilstaende);
      context.commit(SET_SPRACHEN, responseAppApi.data.sprachen);
      context.commit(SET_ANSTELLLUNGS_ARTEN, responseAppApi.data.anstellungsarten);
      context.commit(SET_KOMPETENZSTUFEN, responseAppApi.data.kompetenzstufen);
      context.commit(SET_KANTONE, responseAppApi.data.kantone);
      context.commit(SET_QUALIFIKATION_TYPEN, responseAppApi.data.qualifikationtypen);
      context.commit(SET_QUALIFIKATION_NIVEAU, responseAppApi.data.niveau);
      context.commit(SET_AKADEMISCHER_TITEL, responseAppApi.data.akademischetitel);
      context.commit(
        SET_ADRESS_VERWENDUNG_TYPEN,
        responseAppApi.data.adressverwendungstypen
      );
      context.commit(SET_RELATION_TYPEN, responseAppApi.data.relationtypen);
      context.commit(SET_BRANCHEN, responseAppApi.data.branche);
      context.commit(
        SET_UNTERRICHTSSPRACHEN,
        responseAppApi.data.unterrichtssprachen
      );
      context.commit(SET_EINREICHUNGSTATI, responseAppApi.data.einreichungstati);
      context.commit(SET_KONKORDATE, responseAppApi.data.konkordate);
      context.commit(SET_INSTITUTIONEN, responseAppApi.data.institutionen);
      context.commit(SET_ERNAEHRUNGEN, responseAppApi.data.ernaehrungen || []);
    },
    async [LADE_DOZENTEN](context, status) {
      let response = await Api.get("geschaeftspartner/", {
        params: {
          rollen: this.$CONST("ROLLEN").DOZENTEN.join(),
          status: status,
          count: 1000,
        },
      });
      context.commit(SET_DOZENTEN, response.data.dozenten);
    },
  },
};
